import script from "./SectionPosts.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionPosts.vue?vue&type=script&setup=true&lang=js"

import "./SectionPosts.vue?vue&type=style&index=0&id=bf47730a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf47730a"]])

export default __exports__